import React from "react";
import css from "./contact.module.scss";
import GoogleMaps from "../../components/google-maps/google-maps";
import Seo from "../../components/seo/Seo";
import Reveal from "../../components/animations/Reveal";

const Contact: React.FC = () => {
    return (
        <div className={css.container}>
            <Seo
                title="Contact | BolleNoord 't Zand B.V."
                description="Neem contact op met BolleNoord in 't Zand. Hoofdlocatie: Groteweg 9, 1756 CK 't Zand. Exportspoelerij: Prins Clausweg 1-3, 1756 BJ 't Zand. Tel: +31 224-590404 | E-mail: info@bollenoord.com"
                path="/contact"
            />
            <Reveal variant="fade-right">
                <div className={css.left}>
                    <GoogleMaps/>
                    <div className={css.info}>
                        <h2>Onze gegevens</h2>
                        <p>
                            BolleNoord 't Zand B.V.<br/><br/>
                            <strong>Hoofdlocatie:</strong><br/>
                            Adres: Groteweg 9, 1756 CK 't Zand<br/><br/>
                            <strong>Exportspoelerij:</strong><br/>
                            Prins Clausweg 1-3, 1756 BJ 't Zand<br/>
                            <i>De bocht om bij Prins Clausweg 1, navigatie stopt voordat de straat begint</i><br/>
                            <br/>
                            Telefoon: <a href="tel:+31224590404">+31 224-590404</a><br/>
                            E-mail: <a href="mailto:info@bollenoord.com">info@bollenoord.com</a><br/>
                            KVK: 93341946<br/>
                            BTW: NL86636479B01<br/>
                        </p><br/>
                        <h2>Huur kantoor- en vergaderruimte</h2>
                        <p>Voor het huren van kantoor en/of vergaderruimte kunt u contact opnemen met BolleNoord&nbsp;Plaza.
                            <br/>email: <a href={"mailto:info@bollenoordplaza.com"}> info@bollenoordplaza.com</a></p>
                    </div>
                </div>
            </Reveal>

            <Reveal variant="fade-left">
                <div className={css.right}>
                    <div className={css.contactCard}>
                        <h1 className={css.title}>Neem direct contact op</h1>
                        <p className={css.subtitle}>
                            Wij staan voor u klaar. Kies de contactmethode die het best bij u past.
                        </p>

                        <div className={css.contactOptions}>
                            <a href="tel:+31224590404" className={css.contactOption}>
                                <span className={css.contactIcon}>📞</span>
                                <div className={css.contactOptionText}>
                                    <strong>Bel ons</strong>
                                    <span>+31 224-590404</span>
                                </div>
                            </a>
                            <a href="mailto:info@bollenoord.com" className={css.contactOption}>
                                <span className={css.contactIcon}>✉️</span>
                                <div className={css.contactOptionText}>
                                    <strong>Stuur een e-mail</strong>
                                    <span>info@bollenoord.com</span>
                                </div>
                            </a>
                        </div>

                        <div className={css.openingHours}>
                            <h2>Openingstijden</h2>
                            <table className={css.hoursTable}>
                                <tbody>
                                    <tr><td>Maandag – Donderdag</td><td>07:30 – 17:00</td></tr>
                                    <tr><td>Vrijdag</td><td>07:30 – 15:00</td></tr>
                                    <tr><td>Zaterdag &amp; Zondag</td><td>Gesloten</td></tr>
                                </tbody>
                            </table>
                            <table className={css.hoursTable} style={{marginTop: "0.75rem"}}>
                                <tbody>
                                    <tr><td colSpan={2} style={{fontWeight: 600, paddingBottom: "0.25rem", opacity: 0.85}}>Pauzes</td></tr>
                                    <tr><td>09:30 – 10:00</td><td></td></tr>
                                    <tr><td>12:30 – 13:00</td><td></td></tr>
                                    <tr><td>15:00 – 15:30</td><td></td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Reveal>
        </div>
    );
};

export default Contact;
